import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cow, ArrowRight } from "@phosphor-icons/react";
import api from "@/api";

/**
 * Auto-hides when bingo is disabled. Shows a soft purple CTA card on Info
 * tab that deep-links to /bingo. Also shows the user's current progress.
 */
export default function BingoCTACard() {
  const [state, setState] = useState({ enabled: false, done: 0, total: 25, fullHouse: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: cfg } = await api.get("/bingo/config");
        if (!cfg.enabled || cancelled) return;
        // Fetch status (won't 403 because card-creation is allowed once enabled)
        try {
          const { data: st } = await api.get("/bingo/status");
          if (!cancelled) setState({ enabled: true, done: st.done_count, total: st.total, fullHouse: !!st.full_house });
        } catch {
          if (!cancelled) setState({ enabled: true, done: 0, total: 25, fullHouse: false });
        }
      } catch { /* ignore */ }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!state.enabled) return null;

  return (
    <Link
      to="/bingo"
      data-testid="bingo-cta-card"
      className="block p-4 rounded-sm bg-gradient-to-br from-[#000000] to-[#43C4E3] text-[#FFFFFF] hover:opacity-95 transition-opacity"
    >
      <div className="flex items-center gap-3">
        <Cow size={32} weight="duotone" className="text-[#FFFFFF] flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-mono-time text-[10px] uppercase tracking-widest opacity-80">Win a free DFTB27 ticket</div>
          <div className="font-display text-lg text-[#FFFFFF] leading-tight">
            {state.fullHouse ? "Full house! You're in the draw." : "Play Coo Bingo"}
          </div>
          <div className="text-xs opacity-90 mt-0.5">
            {state.fullHouse
              ? "We'll announce the winner after the conference."
              : `${state.done} of ${state.total} squares done`}
          </div>
        </div>
        <ArrowRight size={20} className="flex-shrink-0" />
      </div>
    </Link>
  );
}
